__turbopack_context__.v({
  "embla__slide": "listing-carousel-slide-module-scss-module__e-4xYq__embla__slide",
  "embla__slide__img": "listing-carousel-slide-module-scss-module__e-4xYq__embla__slide__img",
});
